import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Location } from '../../models/location.model';
import { LoadLocation, SelectLocation } from '../../store/actions/locations.actions';
import { selectSelectedLocation, selectLocationsLoading } from '../../store/selectors/locations.selectors';

@Component({
    selector: 'app-location-detail',
    templateUrl: './location-detail.component.html',
    styleUrls: ['./location-detail.component.css'],
    standalone: false
})
export class LocationDetailComponent implements OnInit, OnDestroy {
  location: Location | null = null;
  locationId: string | null = null;
  isLoading$ = this.store.select(selectLocationsLoading);
  selectedTabIndex = 0;

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<any>
  ) { }

  ngOnInit(): void {
    this.route.params.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      this.locationId = params['locationId'];
      if (this.locationId) {
        this.store.dispatch(new LoadLocation({ id: this.locationId }));
        this.store.dispatch(new SelectLocation({ id: this.locationId }));
      }
    });

    this.store.select(selectSelectedLocation).pipe(
      takeUntil(this.destroy$)
    ).subscribe(location => {
      this.location = location;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.store.dispatch(new SelectLocation({ id: null }));
  }

  onEdit(): void {
    if (this.location) {
      this.router.navigate(['/admin/reservas/editar', this.location.id]);
    }
  }

  onBack(): void {
    this.router.navigate(['/admin/reservas']);
  }

  onTabChange(index: number): void {
    this.selectedTabIndex = index;
  }
}
